import { Users, ShieldAlert, TrendingUp, Handshake } from "lucide-react";

export const PILLARS = [
  {
    id: "citizen_voices",
    name: "Citizen Voices",
    short: "Citizen Voices",
    desc: "Unfiltered community stories, personal encounters, and real perspectives from St. Louis residents.",
    icon: Users,
    color: "#0066FF",
  },
  {
    id: "behind_charges",
    name: "Behind the Charges",
    short: "Behind the Charges",
    desc: "Honest conversations unpacking legal processes, police procedures, and justice system realities.",
    icon: ShieldAlert,
    color: "#FF6B00",
  },
  {
    id: "road_reform",
    name: "The Road to Reform",
    short: "The Road to Reform",
    desc: "Stories of second chances, rebuilding lives, and the community oversight that drives real progress.",
    icon: TrendingUp,
    color: "#10B981",
  },
  {
    id: "bridging_gap",
    name: "Bridging the Gap",
    short: "Bridging the Gap",
    desc: "Roundtables bringing police officers, youth leaders, and elders to the same table.",
    icon: Handshake,
    color: "#8B5CF6",
  },
];

export const pillarMeta = (id) => PILLARS.find((p) => p.id === id) || PILLARS[0];
